import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"

import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
//import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

    const BillPayments = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [payments, setPayments] = useState([])
        const [isLoading, setIsLoading] = useState(false)
        const [areas, setAreas] = useState([])

        
        const [statusOptions, setStatusOptions] = useState(['Open', 'Verified', 'Rejected','Refunded'])
        const [vendorOptions, setVendorOptions] = useState(['eDahab', 'ZAAD'])
        const [currencies, setCurrencies]       = useState(['SLSH', 'USD'])
        const [staff, setStaff] = useState([])

        const [sDate, setSDate]         = useState([new Date()])
        const [eDate, setEDate]         = useState([new Date()])
        const [sArea, setSArea]         = useState('')
        const [sStatus, setSStatus]     = useState('')
        const [sRefNo, setSRefNo]       = useState('')
        const [sPhoneNo, setSPhoneNo]   = useState('')
        const [sCurrency, setSCurrency] = useState('')
        const [sName, setSName]         = useState('')
        const [supplyNo, setSSupplyNo]  = useState('')
        const [sVendor, setSVendor]     = useState('')
        const [sReceiptNo, setSReceiptNo]     = useState('')
        const [sCashierId, setSCashierId]     = useState('')

        const [id, setId] = useState('')
        const [dateTime, setDateTime]           = useState([new Date()])
        const [supNo, setSupNo]                 = useState('')
        const [customer, setCustomer]           = useState('')
        const [phone, setPhone]                 = useState('')
        const [paymentRef, setPaymentRef]       = useState('')
        const [vendor, setVendor]               = useState('')
        const [amountSLSH, setAmountSLSH]       = useState('')
        const [amountUSD, setAmountUSD]         = useState('')
        const [userId, setUserId]               = useState('')
        const [username, setUserName]           = useState('')
        const [status, setStatus]               = useState('Verified')
        const [receiptNo, setReceiptNo]         = useState('')
        const [dateTimeVerified, setDateTimeVerified]  = useState([new Date()])

        const [serverStatus, setServerStatus] = useState('')
        const [serverCashierId, setServerCashierId] = useState('')
        const [serverCashier, setServerCashier] = useState('')
        const [userTitle, setUserTitle] = useState('')
        
        const [modal_cash, setmodal_cash] = useState(false);
        const [modal_cash1, setmodal_cash1] = useState(false);
        const [modal_cash2, setmodal_cash2] = useState(false);
        const [isloading, setIsloading] = useState(false)
        const [newSupplyNo, setNewSupplyNo] = useState('')

        const [btnAction, setBtnAction] = useState('Approve')

        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_cash = () => {
          setmodal_cash(!modal_cash);
          removeBodyCss();
        }
        const tog_cash1 = () => {
          setmodal_cash1(!modal_cash1);
          removeBodyCss();
        }

        const tog_cash2 = () => {
          setmodal_cash2(!modal_cash2);
          removeBodyCss();
        }
       
        const fetchData = () => {
          
          const obj = JSON.parse(localStorage.getItem("authWTUser"));
          
          setUserId(obj.id)
          setUserName(obj.username)
          setUserTitle(obj.category)
          if(obj.category == "CASHIER"){
            setSCashierId(obj.id)
            setSStatus('Open')
          }
          const data = {
            supplyNo  : supplyNo,
            name      : sName,
            phone     : sPhoneNo,
            vendor    : sVendor,
            refno     : sRefNo,
            area      : sArea,
            status    : (obj.category == "CASHIER")? 'Open' :sStatus,
            currency  : sCurrency,
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
            cashierId : (obj.category == "CASHIER")?obj.id:sCashierId
          }
          setIsLoading(true)
          axios.post(`${url.BILLPAYMENTS}`, JSON.stringify(data), Config).then((r)=>{ 
            setPayments(r.data)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
          axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
            setAreas(r.data);
          }).catch((e)=>{  
            console.log(e);
          });

          const udata = {
            id    :"",
            name  :"",
            title :"",
            dept  :"",
            category:"CASHIER",
            area:"PAYMENTS"
          }
          axios.post(url.USERSFILTER, JSON.stringify(udata), Config).then((r)=>{ 
            setStaff(r.data);
            setIsloading(false) 
          }).catch((e)=>{  
            console.log(e); 
            setIsloading(false) 
          });
 
         
        }
        
        useEffect(() => {
          fetchData();
        },[]);

        
        
        const handleFilterData = () =>{
          const data = {
            receiptNo : sReceiptNo,
            supplyNo  : supplyNo,
            name      : sName,
            phone     : sPhoneNo,
            vendor    : sVendor,
            refno     : sRefNo,
            area      : sArea,
            status    : sStatus,
            currency  : sCurrency,
            startDate : formatDate(sDate),
            endDate   : formatDate(eDate),
            cashierId : sCashierId
          }
          
          setIsLoading(true)
          axios.post(`${url.BILLPAYMENTS}`, JSON.stringify(data), Config).then((r)=>{ 
            setPayments(r.data)
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e); 
            setIsLoading(false)
          });
        }
        const handleClearSearch = () =>{
          setSSupplyNo('')
          setSName('')
          setSPhoneNo('')
          setSVendor('')
          setSRefNo('')
          setSArea('')
          setSStatus('')
          setSCurrency('')
          setSDate(new Date())
          setEDate(new Date())
          setSReceiptNo('')
          handleFilterData()
        }

        const handleStatusChange = (e) =>{
           if(e.target.value == 'Refunded'){
              const obj = JSON.parse(localStorage.getItem("authWTUser"));
              if(obj.category == 'CHIEF CASHIER'){
                setStatus(e.target.value)
                setBtnAction('Refund Payment')
              }else{
                toastr.error("Only Chief Cashier can handle refunding")
                setStatus('')
                setBtnAction('Approve')
              }
           }else if(e.target.value == 'Verified'){
              setStatus(e.target.value)
              setBtnAction('Verify Payment')
           }else if(e.target.value == 'Rejected'){
              setStatus(e.target.value)
              setBtnAction('Reject Payment')
           }else{
              setStatus(e.target.value)
           }
        }
        const pageOptions = {
          sizePerPage: 1000,
          totalSize: payments.length, 
          custom: true,
        }
        var node = useRef();
              
        const columns = [

        {
            dataField: 'dateTime',
            text: 'Date',
            sort: true
        },
        {
            dataField: 'supplyNo',
            text: 'Supply No',
            sort: true
        }, 
        {
            dataField: 'customerName',
            text: 'Name',
            sort: true
        },
        {
            dataField: 'phone',
            text: 'Phone No',
            sort: true
        }, 
        {
            dataField: 'refNo',
            text: 'PaymentRef',
            sort: true
        }, 
        {
            dataField: 'vendor',
            text: 'Vendor',
            sort: true
        }, 
        {
            dataField: 'amount',
            text: 'SLSH',
            sort: true,
            formatter: (cell, row) => (parseFloat(cell)).toLocaleString(),
            headerAlign: 'right',
            align: 'right'
        }, 
        {
            dataField: 'amountUSD',
            text: 'USD',
            sort: true,
            formatter: (cell, row) => (parseFloat(cell)).toLocaleString(),
            headerAlign: 'right',
            align: 'right'
        }, 
        {
            dataField: 'status',
            text: 'Status',
            sort: true,
            formatter: statusFormatter
        },
        {
          dataField: '',
          text: '',
          sort: true,
          formatter: actionFormatter
      }
      ];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];

        
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={() => { 
                 
                    handleClickDetails(row); 
                    
                  }}
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if (row.status == "Open") {
            return (
              <div>
                  <Badge className="me-2 bg-warning">{ cellContent }</Badge>
              </div>
            );
          }else if (row.status == "Rejected") {
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }else if (row.status == "Refunded") {
            return (
              <div>
                  <Badge className="me-2 bg-secondary">{ cellContent }</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }
        }
        const handleClickDetails = (row) =>{
          if(['ADMINISTRATOR','CASHIER','CHIEF CASHIER'].includes(userTitle)){
            tog_cash();        
          }else{
            tog_cash1();
          }
          setId(row.id)
          setDateTime(row.dateTime)

          setSupNo(row.supplyNo)
          setCustomer(row.customerName)
          setPhone(row.phone)
          setPaymentRef(row.refNo)
          setVendor(row.vendor)
          setAmountSLSH(row.amount)
          setAmountUSD(row.amountUSD)
          setStatus(row.status)
          setServerStatus(row.status)
          setServerCashier(row.verifiedByName)
          setServerCashierId(row.verifiedBy)
          setReceiptNo(row.receiptNo?row.receiptNo:"");
        }
        const handleClearData = () =>{
          setId('')
          setDateTime('')
          setSupNo('')
          setNewSupplyNo('')
          setCustomer('')
          setPhone('')
          setPaymentRef('')
          setVendor('')
          setAmountSLSH('')
          setAmountUSD('')
          setStatus('')
          setServerStatus('')
          setServerCashier('')
          setServerCashierId('')
          setReceiptNo('')
        }
        const handleSave = ()=>{
          const data = {id: id, status: status, receiptNo: receiptNo, cashierId: userId, action:"verify"}
          setIsloading(true)
          axios.post(url.BILLUPDATE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
              tog_cash()
              toastr.success(r.data.message)
              fetchData();
            }else{
              toastr.error(r.data.message)
            }
            setIsloading(false)
          }).catch((e)=>{
            console.log(e)
            setIsloading(false)
          })
        }
        const handleSave2 = () =>{
          const data = {
            dateTime    : formatDate(dateTime), 
            supplyNo    : supNo, 
            customerName: customer, 
            phoneNo     : phone,
            paymentRef  : paymentRef,
            vendor      : vendor,
            amountSLSH  : amountSLSH,
            amountUSD   : amountUSD,
            status      : status,
            receiptNo   : receiptNo,
            cashierId   : userId
          }
        
          setIsloading(true)
          axios.post(url.BILLADD, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
              tog_cash2()
              handleClearData()
              toastr.success(r.data.message)
              fetchData();
            }else{
              toastr.error(r.data.message)
            }
            setIsloading(false)
          }).catch((e)=>{
            console.log(e)
            setIsloading(false)
          })
          
        }
        const handleUpdatePayment = () =>{
          const data = {id: id, status: status, receiptNo: receiptNo, cashierId: userId, supplyNo: newSupplyNo, action: "update"}
          setIsloading(true)
          axios.post(url.BILLUPDATE, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == 1){
              tog_cash()
              toastr.success(r.data.message)
              fetchData();
            }else{
              toastr.error(r.data.message)
            }
            setIsloading(false)
          }).catch((e)=>{
            console.log(e)
            setIsloading(false)
          })
        }
        const handleExport = () =>{
            const data = {
              receiptNo : sReceiptNo,
              supplyNo  : supplyNo,
              name      : sName,
              phone     : sPhoneNo,
              vendor    : sVendor,
              refno     : sRefNo,
              area      : sArea,
              status    : sStatus,
              currency  : sCurrency,
              startDate : formatDate(sDate),
              endDate   : formatDate(eDate),
              cashierId : sCashierId
            }
            setIsLoading(true)
            axios.post(`${url.BILLPAYMENTSREPORT}`, JSON.stringify(data), Config).then((r)=>{ 
              setPayments(r.data)
              const urlx = url.APACHE_URL + "attach/bill_output.xlsx"
              axios({
                url: urlx,
                method: 'GET',
                responseType: 'blob',
              })
              .then((response) => {
                 const url = window.URL.createObjectURL(new Blob([response.data]));
                 const link = document.createElement('a');
                 link.href = url;
                 link.setAttribute('download', `Bill-Payments-Report.xlsx`);
                 document.body.appendChild(link);
                 link.click();
                 document.body.removeChild(link);
                 window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                 console.error('Error downloading the file:', error);
               });
              setIsLoading(false)
            }).catch((e)=>{  
              console.log(e); 
              setIsLoading(false)
            });
        }
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Bill Payments | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                      <Modal isOpen={modal_cash} toggle={() => { tog_cash();}} centered>
                        <div className="modal-header">
                          <h5 className="modal-title mt-0" id="myModalLabel">{ 'Payment' }</h5>
                          <button onClick={() => { setmodal_cash(false);}}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                        <Row>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Date time</label>
                                    <Flatpickr
                                      className="form-control"
                                      options={{ altInput: true, enableTime: false, dateFormat: "Y-m-d", disabled: true }}
                                      value={dateTime}
                                      disabled={true}
                                      onChange={(dates)=>setDateTime(dates)}
                                      />
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Supply No</label>
                                    <input type="text" className="form-control" value={supNo} disabled={(userTitle == 'ADMINISTRATOR')?false:true} onChange={(e)=>{setSupNo(e.target.value); setNewSupplyNo(e.target.value)}}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Customer name</label>
                                    <input type="text" className="form-control" defaultValue={customer} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Phone</label>
                                    <input type="text" className="form-control" defaultValue={phone} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Payment Ref</label>
                                    <input type="text" className="form-control" defaultValue={paymentRef} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Vendor</label>
                                    <input type="text" className="form-control" defaultValue={vendor} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Amount SLSH</label>
                                    <input type="text" className="form-control" defaultValue={amountSLSH} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Amount USD</label>
                                    <input type="text" className="form-control" defaultValue={amountUSD} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label>Status</label>
                                    <select className="form-select" value={status} 
                                     onChange={handleStatusChange} disabled={(((userId == serverCashierId) && (serverStatus == "Open")) || (userTitle == 'ADMINISTRATOR') || (userTitle == 'CHIEF CASHIER'))?false:true}>
                                      {statusOptions.map((s,k)=>(
                                        <option key={k} value={s}>{s}</option>
                                      ))}
                                    </select>
                                </div>
                            </Col>
                            
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label>Receipt number</label>
                                    <input type="text" className="form-control" value={receiptNo} 
                                    onChange={(e)=>{ (e.target.value.length <= 9) ? setReceiptNo(e.target.value): null }} disabled={(( ((userId == serverCashierId) && (serverStatus == "Open")) || (userTitle == 'ADMINISTRATOR') || (userTitle == 'CHIEF CASHIER') ))?false:true}/>
                                </div>
                            </Col>
                            
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label>Cashier</label>
                                    <input type="text" className="form-control" defaultValue={serverCashier} disabled={true}/>
                                </div>
                            </Col>
                            
                        </Row>
                        </div>         
                        <div className="modal-footer">
                          {isloading?`Please wait...`:(<>
                          <button  onClick={() => { tog_cash(); }} className="btn btn-danger" data-dismiss="modal">Close</button>
                          {(userTitle == 'ADMINISTRATOR') && <button  onClick={() => { handleUpdatePayment(); }} className="btn btn-warning" data-dismiss="modal">Update Supply No</button>}
                          {(((userId == serverCashierId) && (serverStatus == "Open")) || (userTitle == 'ADMINISTRATOR') || (userTitle == 'CHIEF CASHIER')) && <button className="btn btn-success" onClick = {()=>{handleSave()}}>{btnAction}</button>}
                          </>)}
                        </div>
                      </Modal>


                      <Modal isOpen={modal_cash1} toggle={() => { tog_cash1();}} centered>
                        <div className="modal-header">
                          <h5 className="modal-title mt-0" id="myModalLabel">{ 'Payment details' }</h5>
                          <button onClick={() => { setmodal_cash1(false);}}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                        <Row>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Date time</label>
                                    <Flatpickr
                                      className="form-control"
                                      options={{ altInput: true, enableTime: false, dateFormat: "Y-m-d", disabled: true }}
                                      value={dateTime}
                                      disabled={true}
                                      onChange={(dates)=>setDateTime(dates)}
                                      />
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Supply No</label>
                                    <input type="text" className="form-control" defaultValue={supNo} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Customer name</label>
                                    <input type="text" className="form-control" defaultValue={customer} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Phone</label>
                                    <input type="text" className="form-control" defaultValue={phone} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Payment Ref</label>
                                    <input type="text" className="form-control" defaultValue={paymentRef} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Vendor</label>
                                    <input type="text" className="form-control" defaultValue={vendor} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Amount SLSH</label>
                                    <input type="text" className="form-control" defaultValue={amountSLSH} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Amount USD</label>
                                    <input type="text" className="form-control" defaultValue={amountUSD} disabled={true}/>
                                </div>
                            </Col>
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label>Status</label>
                                    <select className="form-select" defaultValue={status}  disabled={true}>
                                      {statusOptions.map((s,k)=>(
                                        <option key={k} value={s}>{s}</option>
                                      ))}
                                    </select>
                                </div>
                            </Col>
                            
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label>Receipt number</label>
                                    <input type="text" className="form-control" value={receiptNo} 
                                    onChange={(e)=>{ (e.target.value.length <= 9) ? setReceiptNo(e.target.value): null }} disabled={true}/>
                                </div>
                            </Col>
                            
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label>Cashier</label>
                                    <input type="text" className="form-control" defaultValue={serverCashier} disabled={true}/>
                                </div>
                            </Col>
                            
                        </Row>
                        </div>         
                        <div className="modal-footer">
                          {isloading?`Please wait...`:(<>
                          <button  onClick={() => { tog_cash1(); }} className="btn btn-danger" data-dismiss="modal">Close</button>
                          
                          </>)}
                        </div>
                      </Modal>

                      <Modal isOpen={modal_cash2} toggle={() => { tog_cash2();}} centered>
                        <div className="modal-header">
                          <h5 className="modal-title mt-0" id="myModalLabel">{ 'Add Payment details' }</h5>
                          <button onClick={() => { setmodal_cash2(false);}}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                        <Row>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Date time</label>
                                    <Flatpickr
                                      className="form-control"
                                      options={{ altInput: true, enableTime: false, dateFormat: "Y-m-d", disabled: true }}
                                      value={dateTime}
                                      disabled={false}
                                      onChange={(dates)=>setDateTime(dates)}
                                      />
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Supply No</label>
                                    <input type="text" className="form-control" value={supNo} onChange={(e)=>setSupNo(e.target.value)}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Customer name</label>
                                    <input type="text" className="form-control" value={customer} onChange={(e)=>setCustomer(e.target.value)}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Phone</label>
                                    <input type="text" className="form-control" placeholder='631234567' value={phone} onChange={(e)=>setPhone(e.target.value)}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Payment Ref</label>
                                    <input type="text" className="form-control" value={paymentRef} onChange={(e)=>setPaymentRef(e.target.value)}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Vendor</label>
                                    <select className="form-select" value={vendor}  onChange={(e)=>setVendor(e.target.value)}>
                                    <option value=""></option>
                                      {vendorOptions.map((s,k)=>(
                                        <option key={k} value={s}>{s}</option>
                                      ))}
                                    </select>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Amount SLSH</label>
                                    <input type="number" className="form-control" value={amountSLSH} onChange={(e)=>setAmountSLSH(e.target.value)}/>
                                </div>
                            </Col>
                            <Col xl={6}>
                                <div className="mb-3">
                                    <label>Amount USD</label>
                                    <input type="number" className="form-control" value={amountUSD} onChange={(e)=>setAmountUSD(e.target.value)}/>
                                </div>
                            </Col>
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label>Status</label>
                                    <select className="form-select" value={status}  onChange={(e)=>setStatus(e.target.value)}>
                                    <option value=""></option>
                                      {statusOptions.map((s,k)=>(
                                        <option key={k} value={s}>{s}</option>
                                      ))}
                                    </select>
                                </div>
                            </Col>
                            
                            <Col xl={12}>
                                <div className="mb-3">
                                    <label>Receipt number</label>
                                    <input type="text" className="form-control" value={receiptNo} 
                                    onChange={(e)=>{ (e.target.value.length <= 9) ? setReceiptNo(e.target.value): null }} />
                                </div>
                            </Col>
                            
                        </Row>
                        </div>         
                        <div className="modal-footer">
                          {isloading?`Please wait...`:(<>
                          <button  onClick={() => { tog_cash2(); }} className="btn btn-danger" data-dismiss="modal">Close</button>
                          <button className="btn btn-success" onClick = {()=>{handleSave2()}}>Add Payment</button>
                          
                          </>)}
                        </div>
                      </Modal>
                     
                        <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
                                
                  
                                

                                                <Row className="justify-content-center mb-1">
                                                <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Supply Number</label>
                                                          <input type='text' className="form-control form-control-sm" value={supplyNo} onChange={(e)=>setSSupplyNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Receipt Number</label>
                                                          <input type='text' className="form-control form-control-sm" value={sReceiptNo} onChange={(e)=>setSReceiptNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Reference No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sRefNo} onChange={(e)=>setSRefNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Phone No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sPhoneNo} onChange={(e)=>setSPhoneNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Customer Name</label>
                                                          <input type='text' className="form-control form-control-sm" value={sName} onChange={(e)=>setSName(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                </Row>
                                                <Row className="justify-content-center mb-3">
                                                
                                                <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Vendor</label>
                                                          <select className="form-select form-select-sm" value={sVendor} onChange={(e)=>setSVendor(e.target.value)}>
                                                          <option value="">All</option>
                                                              {vendorOptions.map((s,k)=>(
                                                                  <option value={s} key={k}>{s}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>From</label>
                                                          <Flatpickr
                                                            className="form-control form-control-sm"
                                                            options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false
                                                            }}
                                                            value={sDate}
                                                            onChange={(dates)=>setSDate(dates)}
                                                            />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Till </label>
                                                          <Flatpickr
                                                              className="form-control form-control-sm"
                                                              options={{
                                                                  dateFormat: "Y-m-d",
                                                                  enableTime: false
                                                              }}
                                                              value={eDate}
                                                              onChange={(dates)=>setEDate(dates)}
                                                              />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Cashier</label>
                                                          <select className="form-select form-select-sm" value={sCashierId} onChange={(e)=>setSCashierId(e.target.value)}>
                                                          <option value={``}>All</option>
                                                          {staff.map((a,k)=>(
                                                              <option key={k} value={a.id}>{a.name} - {a.deptName}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                          <option value="">All</option>
                                                              {statusOptions.map((s,k)=>(
                                                                  <option value={s} key={k}>{s}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                 {/*} <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>District</label>
                                                          <select className="form-select form-select-sm" value={sArea} onChange={(e)=>setSArea(e.target.value)}>
                                                          <option value=""></option>
                                                              {areas.map((c,k)=>(
                                                                  <option value={c.id} key={k}>{c.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>*/}
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Currency</label>
                                                          <select className="form-select form-select-sm" value={sCurrency} onChange={(e)=>setSCurrency(e.target.value)}>
                                                          <option value=""></option>
                                                              {currencies.map((c,k)=>(
                                                                  <option value={c} key={k}>{c}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                
                                                 
                                                  
                                                  
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='info'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleExport()}}
                                                      >
                                                        <i className="mdi mdi-export me-1" />
                                                        Export to Excel
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  {(['ADMINISTRATOR'].includes(userTitle)) && 
                                                  <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{ handleClearData(); tog_cash2() }}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add Payment
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  }
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h6 className="card-header bg-transparent border-bottom text-uppercase">
                                                Transactions: {payments.length}, &nbsp; 
                                                Verified: {payments.filter(entry => entry.status === 'Verified').length}, &nbsp; 
                                                Open: {payments.filter(entry => entry.status === 'Open').length}, &nbsp; 
                                                Rejected: {payments.filter(entry => entry.status === 'Rejected').length}, &nbsp;
                                                Refunded: {payments.filter(entry => entry.status === 'Refunded').length}, &nbsp;&nbsp;
                                                
                                                SLSH: {payments.filter(entry => entry.status === 'Verified').reduce((total, entry) => total + parseFloat(entry.amount), 0).toLocaleString()}/- &nbsp; 
                                                USD: {payments.filter(entry => entry.status === 'Verified').reduce((total, entry) => total + parseFloat(entry.amountUSD), 0).toLocaleString()}/-</h6>
                                                  <CardBody>

                                                  
                                            
                                {(payments.length > 0) && (

                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="id"
                                    columns={columns}
                                    data={payments}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="id"
                                      data={payments}
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  keyField='id' 
                                                  data={payments} 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {payments && (payments.length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No Payments found</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                  
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default BillPayments;